import { ComponentType, Fragment, ReactNode, useEffect, useState } from "react";

export interface AsyncWrapperProps {
  /** The function which asynchronously resolves the component to render. */
  readonly resolver: () => Promise<ComponentType | undefined>;

  /** The optional children. */
  readonly children?: ReactNode;
}

export const AsyncWrapper = (props: AsyncWrapperProps) => {
  const { resolver, children } = props;
  const [Component, setComponent] = useState<ComponentType<{ children?: ReactNode }>>(() => Fragment);

  useEffect(() => {
    async function resolveComponent() {
      const component = (await resolver()) ?? Fragment;
      setComponent(() => component);
    }

    resolveComponent();
  }, [resolver]);

  return <Component>{children}</Component>;
};
